/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RapportHopeParameterDataDto
 */
export interface RapportHopeParameterDataDto {
    /**
     * 
     * @type {string}
     * @memberof RapportHopeParameterDataDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportHopeParameterDataDto
     */
    value?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RapportHopeParameterDataDto
     */
    values?: Array<string> | null;
}

/**
 * Check if a given object implements the RapportHopeParameterDataDto interface.
 */
export function instanceOfRapportHopeParameterDataDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RapportHopeParameterDataDtoFromJSON(json: any): RapportHopeParameterDataDto {
    return RapportHopeParameterDataDtoFromJSONTyped(json, false);
}

export function RapportHopeParameterDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapportHopeParameterDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'values': !exists(json, 'values') ? undefined : json['values'],
    };
}

export function RapportHopeParameterDataDtoToJSON(value?: RapportHopeParameterDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
        'values': value.values,
    };
}

